export default {
	TABLE_NAME: 'Ingredient variant options',
	INGREDIENT_VARIANT_OPTION_EDITED: 'Ingredient variant option edited.',
	INGREDIENT_VARIANT_OPTION_DELETED: 'Ingredient variant option deleted.',
	INGREDIENT_VARIANT_OPTION_ADDED: 'Ingredient variant option added.'
};
